const canMove =  (source, blocIdx) => source.data.blocIdx !== blocIdx && source.data.blocIdx + 1 !== blocIdx

export { canMove };